import { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getToken } from '@/utils/common';

interface NonLoginProps {
  children: ReactElement;
}

export default function NonLogin({ children }: NonLoginProps) {
  const token = getToken();
  const location = useLocation();
  const hasInvitationReturn = Boolean(
    new URLSearchParams(location.search).get('invitationId') ||
      new URLSearchParams(location.search).get('returnUrl'),
  );

  // Nếu đã đăng nhập (có token) thì redirect về dashboard
  if (token && !hasInvitationReturn) {
    return <Navigate to="/dashboard" replace />;
  }

  // Nếu chưa đăng nhập thì hiển thị trang login
  return children;
}
